import axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { SESSION_GET_ITEM, SESSION_GET_TOKEN } from "Components/constants/enums";


export const baseURL = process.env.REACT_APP_BASE_URL as string 
export const BaseImageURL = process.env.REACT_APP_BASE_IMAGE_URL as string;

export const createAxiosInstance = (baseURL: string): AxiosInstance => {
  const Bearer = "Bearer";
  const instance = axios.create({
    baseURL: baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  instance.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      if (config && config.headers) {
        const authToken = SESSION_GET_TOKEN()
        if (authToken) {
          config.headers["Authorization"] = `${Bearer} ${authToken}`;
        }
      }
      return config;
    }
  );

  return instance;
};

export const createNonAuthAxiosInstance = (
  baseURL: string,
  contentType: string = "application/json"
): AxiosInstance => {
  return axios.create({
    baseURL: baseURL,
    headers: {
      "Content-Type": contentType,
    },
  });
};

export const createAuthAxiosInstance = (baseURL: string): AxiosInstance => {
  const Bearer = "Bearer";
  
  const instance = axios.create({
    baseURL: baseURL,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  instance.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      if (config && config.headers) {
        const authToken = SESSION_GET_ITEM("authToken")
        if (authToken) {
          config.headers["Authorization"] = `${Bearer} ${authToken}`;
        }
      }
      return config;
    }
  );

  return instance;
};

export const authData = createAxiosInstance(baseURL);
export const nonAuthData = createNonAuthAxiosInstance(baseURL);
export const multipartData = createNonAuthAxiosInstance(
  baseURL,
  "multipart/form-data"
);
export const multipartDataWithToken = createAuthAxiosInstance(baseURL);
